import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';

import AuditReasons from './auditreasons';
import DxSectionListItem from './listitem';
import { GlobalHotKeys } from '../../../../node_modules/react-hotkeys';
import keyMap from './dxsectionhotkeymap';

const noOp = () => {};

export const useDxSectionStyles = makeStyles(theme => ({
  topButtonContainer: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'nowrap',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '0.5em',
    borderBottom: 'solid #000 1px',
    '& button + button': {
      marginLeft: '0.4em'
    }
  },
  auditReasonsContainer: {
    '& h5': {
      marginBottom:'0px'
    }
  },
  hiddenContainer:{
    display:'none'
  },
  auditReasonItem: {
    height:'22px',
    '& input': {
      height:'18px',
      width:'18px',
      verticalAlign:'middle'
    },
    '& span': {
      verticalAlign:'middle'
    },
    '& label': {
      display:'inline-block',
      whiteSpace:'nowrap'
    }
  }
}));

const DxSection = ({
  encounterId,
  listItems,
  openAddDxDialog,
  openAddReasonOptionDialog,
  unapproveDx,
  unremoveDx,
  encounterAuditReasons,
  isMultiselect,
  multiselectItems,
  beginMultiselect,
  endMultiselect,
  selectItemMultiselect,
  deselectItemMultiselect,
  dateOfService,
  isAuditResolutionDialogVisible,
  openAuditResolutionDialog,
  closeAuditResolutionDialog,
  resolveAuditReason,
  selectedAuditReasonId,
  selectedAuditReasonIsResolvedValue,
  auditResolutionOptions,
  selectAuditResolutionOption,
  selectedAuditResolutionOptionId,
  hydrateEncounterAuditReasons,
  isReview = false,
  isAudit = false
}) => {
  const classes = useDxSectionStyles();

  const selectDxMultiShortcut = optionNumber => {
    if (optionNumber >= listItems.length) return;

    const dx = listItems[optionNumber];
    const isSelectedItem = multiselectItems.indexOf(dx.encounterCmsCodeId) > -1;

    if (isMultiselect === true) {
      if (isSelectedItem) {
        deselectItemMultiselect(dx);
        if (listItems.length <= 1)
          endMultiselect();
      }
      else {
        selectItemMultiselect(dx)
      }
    }
    else {
      beginMultiselect(dx)
    }
  }

  const selectAllDxMultiShortcut = () => {
    if (listItems.length === multiselectItems.length && listItems.length > 0) {
      listItems.forEach(item => {
        deselectItemMultiselect(item);
      });
    }
    else {
      beginMultiselect(listItems);
    }
  }

  const removeDxShortcut = optionNumber => {
    if (optionNumber >= listItems.length) return;

    const dx = listItems[optionNumber];
    if (dx.isRemoved) {
      unremoveDx(encounterId, [dx.encounterCmsCodeId]);
    }
    else {
      openAddReasonOptionDialog(
        'Remove',
        [dx.encounterCmsCodeId]
      )
    }
  }

  const approveDxShortcut = optionNumber => {
    if (optionNumber >= listItems.length) return;

    const dx = listItems[optionNumber];
    if (dx.isApproved) {
      unapproveDx(encounterId, [dx.encounterCmsCodeId]);
    }
    else {
      openAddReasonOptionDialog(
        'Approve',
        [dx.encounterCmsCodeId]
      )
    }
  }

  const approveSelectedDxes = () => {
    const ids = isMultiselect === true
                ? multiselectItems
                : listItems.map(x => x.encounterCmsCodeId);
    openAddReasonOptionDialog(
      'Approve',
      ids
    );
  }

  const removeSelectedDxes = () => {
    const ids = isMultiselect === true
                ? multiselectItems
                : listItems.map(x => x.encounterCmsCodeId);
    openAddReasonOptionDialog(
      'Remove',
      ids
    );
  }

  const approveAllDxes = () => {
    const ids = listItems.map(x => x.encounterCmsCodeId);
    openAddReasonOptionDialog(
      'Approve',
      ids
    );
  }

  const removeAllDxes = () => {
    const ids = listItems.map(x => x.encounterCmsCodeId);
    openAddReasonOptionDialog(
      'Remove',
      ids
    );
  }

  const selectDxMultiHandler = (isReview) ? noOp : selectDxMultiShortcut;
  const selectAllDxMultiHandler = (isReview) ? noOp : selectAllDxMultiShortcut;
  const removeDxHandler = (isReview) ? noOp : removeDxShortcut;
  const approveDxHandler = (isReview) ? noOp : approveDxShortcut;
  const approveSelectedDxHandler = (!isReview && isMultiselect && multiselectItems.length > 0) ? approveSelectedDxes : noOp;
  const removeSelectedDxHandler = (!isReview && isMultiselect && multiselectItems.length > 0) ? removeSelectedDxes : noOp;
  const approveAllHander = (isReview) ? noOp : approveAllDxes;
  const removeAllHandler = (isReview) ? noOp : removeAllDxes;
  const addNewDxHandler = (isReview) ? noOp : openAddDxDialog;

  const keyHandlers = {
    MULTISELECT_ALL: event => {
      event.preventDefault();
      selectAllDxMultiHandler();
    },
    ADD_NEW_DX: event => {
      event.preventDefault();
      addNewDxHandler();
    },
    SELECT_DX_ONE: event => {
      event.preventDefault();
      selectDxMultiHandler(0)
    },
    SELECT_DX_TWO: event => {
      event.preventDefault();
      selectDxMultiHandler(1)
    },
    SELECT_DX_THREE: event => {
      event.preventDefault();
      selectDxMultiHandler(2)
    },
    SELECT_DX_FOUR: event => {
      event.preventDefault();
      selectDxMultiHandler(3)
    },
    SELECT_DX_FIVE: event => {
      event.preventDefault();
      selectDxMultiHandler(4)
    },
    SELECT_DX_SIX: event => {
      event.preventDefault();
      selectDxMultiHandler(5)
    },
    SELECT_DX_SEVEN: event => {
      event.preventDefault();
      selectDxMultiHandler(6)
    },
    SELECT_DX_EIGHT: event => {
      event.preventDefault();
      selectDxMultiHandler(7)
    },
    SELECT_DX_NINE: event => {
      event.preventDefault();
      selectDxMultiHandler(8)
    },
    REMOVE_DX_ONE: event => {
      event.preventDefault();
      removeDxHandler(0);
    },
    REMOVE_DX_TWO: event => {
      event.preventDefault();
      removeDxHandler(1);
    },
    REMOVE_DX_THREE: event => {
      event.preventDefault();
      removeDxHandler(2);
    },
    REMOVE_DX_FOUR: event => {
      event.preventDefault();
      removeDxHandler(3);
    },
    REMOVE_DX_FIVE: event => {
      event.preventDefault();
      removeDxHandler(4);
    },
    REMOVE_DX_SIX: event => {
      event.preventDefault();
      removeDxHandler(5);
    },
    REMOVE_DX_SEVEN: event => {
      event.preventDefault();
      removeDxHandler(6);
    },
    REMOVE_DX_EIGHT: event => {
      event.preventDefault();
      removeDxHandler(7);
    },
    REMOVE_DX_NINE: event => {
      event.preventDefault();
      removeDxHandler(8);
    },
    APPROVE_DX_ONE: event => {
      event.preventDefault();
      approveDxHandler(0);
    },
    APPROVE_DX_TWO: event => {
      event.preventDefault();
      approveDxHandler(1);
    },
    APPROVE_DX_THREE: event => {
      event.preventDefault();
      approveDxHandler(2);
    },
    APPROVE_DX_FOUR: event => {
      event.preventDefault();
      approveDxHandler(3);
    },
    APPROVE_DX_FIVE: event => {
      event.preventDefault();
      approveDxHandler(4);
    },
    APPROVE_DX_SIX: event => {
      event.preventDefault();
      approveDxHandler(5);
    },
    APPROVE_DX_SEVEN: event => {
      event.preventDefault();
      approveDxHandler(6);
    },
    APPROVE_DX_EIGHT: event => {
      event.preventDefault();
      approveDxHandler(7);
    },
    APPROVE_DX_NINE: event => {
      event.preventDefault();
      approveDxHandler(8);
    },
    APPROVE_SELECTED: event => {
      event.preventDefault();
      approveSelectedDxHandler();
    },
    REMOVE_SELECTED: event => {
      event.preventDefault();
      removeSelectedDxHandler();
    },
    APPROVE_ALL: event => {
      event.preventDefault();
      approveAllHander();
    },
    REMOVE_ALL: event => {
      event.preventDefault();
      removeAllHandler();
    }
  }

  return (
    <GlobalHotKeys keyMap={keyMap} handlers={keyHandlers} allowChanges={true}>
      <div>
        { encounterAuditReasons && (isAudit || isReview) &&
          <AuditReasons
            isAudit={isAudit}
            isReview={isReview}
            encounterAuditReasons={encounterAuditReasons}
            isAuditResolutionDialogVisible={isAuditResolutionDialogVisible}
            resolveAuditReason={resolveAuditReason}
            openAuditResolutionDialog={openAuditResolutionDialog}
            closeAuditResolutionDialog={closeAuditResolutionDialog}
            selectedAuditReasonId={selectedAuditReasonId}
            selectedAuditReasonIsResolvedValue={selectedAuditReasonIsResolvedValue}
            auditResolutionOptions={auditResolutionOptions}
            selectAuditResolutionOption={selectAuditResolutionOption}
            selectedAuditResolutionOptionId={selectedAuditResolutionOptionId}
            hydrateEncounterAuditReasons={hydrateEncounterAuditReasons}
          />
        }
        <div className={classes.topButtonContainer}>
          <button
            disabled={isReview}
            onClick={() => {
              approveSelectedDxes();
            }}
          >
            {
              isMultiselect === true
                ? 'Approve Selected'
                : 'Approve All'
            }
          </button>

          <button
            disabled={isReview}
            onClick={() => {
              removeSelectedDxes();
            }}
          >
            {
              isMultiselect === true
                ? 'Remove Selected'
                : 'Remove All'
            }
          </button>

          <button
            disabled={isReview}
            onClick={openAddDxDialog}
          >
            <span>Add Dx</span>
          </button>
        </div>
        <div>
          {
            listItems.map(x => (
              <DxSectionListItem
                key={x.encounterCmsCodeId}
                encounterId={encounterId}
                dx={x}
                unapproveDx={unapproveDx}
                unremoveDx={unremoveDx}
                openAddReasonOptionDialog={openAddReasonOptionDialog}
                isReview={isReview}
                isAudit={isAudit}
                isMultiselect={isMultiselect}
                multiselectItems={multiselectItems}
                beginMultiselect={beginMultiselect}
                endMultiselect={endMultiselect}
                selectItemMultiselect={selectItemMultiselect}
                deselectItemMultiselect={deselectItemMultiselect}
                dateOfService={dateOfService}
              />
            ))
          }
        </div>
      </div>
    </GlobalHotKeys>
  );
};

DxSection.propTypes = {
  encounterId: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string
  ]).isRequired,
  listItems: PropTypes.array.isRequired,
  openAddDxDialog: PropTypes.func.isRequired,
  openAddReasonOptionDialog: PropTypes.func.isRequired,
  unapproveDx: PropTypes.func.isRequired,
  unremoveDx: PropTypes.func.isRequired,
  isReview: PropTypes.bool.isRequired,
  isAudit: PropTypes.bool.isRequired,
  encounterAuditReasons: PropTypes.array,
  isMultiselect: PropTypes.bool.isRequired,
  multiselectItems: PropTypes.array.isRequired,
  beginMultiselect: PropTypes.func.isRequired,
  endMultiselect: PropTypes.func.isRequired,
  selectItemMultiselect: PropTypes.func.isRequired,
  deselectItemMultiselect: PropTypes.func.isRequired,
  isAuditResolutionDialogVisible: PropTypes.bool.isRequired,
  openAuditResolutionDialog: PropTypes.func.isRequired,
  closeAuditResolutionDialog: PropTypes.func.isRequired,
  resolveAuditReason: PropTypes.func.isRequired,
  selectedAuditReasonId: PropTypes.number.isRequired,
  selectedAuditReasonIsResolvedValue: PropTypes.bool.isRequired,
  auditResolutionOptions: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.number.isRequired,
    label: PropTypes.string.isRequired
  })).isRequired,
  selectAuditResolutionOption: PropTypes.func.isRequired,
  selectedAuditResolutionOptionId: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string
  ]).isRequired,
  hydrateEncounterAuditReasons: PropTypes.func.isRequired
};

export default DxSection;
